import { createBrowserRouter } from 'react-router'
import AdminLayout     from '../layouts/AdminLayout'
import Login           from '../screens/Login'
import Dashboard       from '../screens/Dashboard'
import Empresas        from '../screens/Empresas'
import TenantDetail    from '../screens/TenantDetail'
import Wizard          from '../screens/Wizard'
import Backup          from '../screens/Backup'
import DbHealth        from '../screens/DbHealth'
import Anulaciones     from '../screens/Anulaciones'
import Alertas         from '../screens/Alertas'
import Reportes        from '../screens/Reportes'
import Catalogos       from '../screens/Catalogos'
import Logs            from '../screens/Logs'
import WhatsappLogs    from '../screens/WhatsappLogs'
import NotFound        from '../screens/NotFound'

const router = createBrowserRouter(
  [
    { path: '/login', element: <Login /> },
    {
      path: '/',
      element: <AdminLayout />,
      children: [
        { index: true,                   element: <Dashboard /> },
        { path: 'empresas',              element: <Empresas /> },
        { path: 'empresas/:id',          element: <TenantDetail /> },
        { path: 'wizard',               element: <Wizard /> },
        { path: 'db-health',            element: <DbHealth /> },
        { path: 'backup',               element: <Backup /> },
        { path: 'anulaciones',          element: <Anulaciones /> },
        { path: 'alertas',              element: <Alertas /> },
        { path: 'reportes',             element: <Reportes /> },
        { path: 'logs',                 element: <Logs /> },
        { path: 'whatsapp-logs',        element: <WhatsappLogs /> },
        { path: 'catalogos',            element: <Catalogos /> },
        { path: '*',                    element: <NotFound /> },
      ],
    },
  ],
  { basename: '/backoffice' }
)

export default router
